// @core/api/endpoints/booking/list_bookings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBookingsResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List bookings
 * Returns bookings filtered by status, resource, date range, and booking type.
 */
export async function ListBookings(
  params?: {
    booking_type_id?: string | number | boolean;
    cursor?: string | number | boolean;
    date_from?: string | number | boolean;
    date_to?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    resource_id?: string | number | boolean;
    sort?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListBookingsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/bookings`;
  const requestOptions = options;
  return client.get<ListBookingsResponse>(requestPath, { ...requestOptions, params });
}
